import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const CONNECT_NATIVE_TO_GAM: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation connectNativeToGam($input: ConnectNativeToGamInput!) {
    connectNativeToGam(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
